import React from 'react';

import { EchoNavigate, EchoSlot, useEcho } from '@betterment/js-runtime';
import { useLoaderData } from 'react-router-dom';

import { FullPageLoader } from '../../FullPageLoader';
import { Layout } from '../../InstitutionalApp/Layout';
import { Header } from '../Header';

export const EchoRoute: React.FC = () => {
  const { echo, onSubmit } = useEcho(useLoaderData());

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return (
    <Layout active="clients">
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content>
        <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />
      </Layout.Content>
    </Layout>
  );
};
